import type { FC } from 'react';
import { useCallback, useState } from 'react';
import { Snackbar } from 'react-native-paper';

export type ToastProps = {
  isVisible: boolean;
  isClosable?: boolean;
  message: string;
  duration?: number;
  onClose?: () => void;
};

export const Toast: FC<ToastProps> = ({
  isVisible,
  isClosable = true,
  message,
  duration = 5000,
  onClose
}) => {
  const [visible, setVisible] = useState<boolean>(isVisible);

  const handleDismiss = useCallback(() => {
    setVisible(false);
    if (onClose) onClose();
  }, [onClose]);

  return (
    <Snackbar
      visible={visible}
      duration={duration}
      onDismiss={handleDismiss}
      onIconPress={isClosable ? handleDismiss : undefined}
    >
      {message}
    </Snackbar>
  );
};
